<template>
  <div class="login">
    <div class="icon-container icon-checkstatus"></div>
    <div class="title">{{ $t('forgotPassword.emailSend') }}</div>
    <div class="info">
      {{ $t('forgotPassword.emailSendInfo', { email: $route.params.emailKey }) }}
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
@use '@/styles/register.scss';

.icon-container {
  margin: 0 auto 24px;
}

.icon-checkstatus::before {
  margin: auto;
  width: 48px;
  height: 48px;
  font-size: 48px;
  color: #1daea1;
}
</style>
